import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SessionCheckScreen from './SessionCheckScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, authReady, serverUnreachable } = useAuth();
  const location = useLocation();

  // A new tab (or a browser that was closed) knows who is signed in only after
  // the session check. Redirecting before it sent signed-in users to the login.
  if (!isAuthenticated && !authReady) {
    return <SessionCheckScreen serverUnreachable={serverUnreachable} />;
  }

  if (!isAuthenticated) {
    // Redirect to login page but save the location they were
    // trying to access so we can redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 